/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { TasksApiConfiguration as __Configuration } from '../tasks-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ListQueryResultTaskRoleInfo } from '../models/list-query-result-task-role-info';
import { CreateTaskRoleCommand } from '../models/create-task-role-command';
import { UpdateTaskRoleCommand } from '../models/update-task-role-command';
@Injectable({
  providedIn: 'root',
})
class TaskRoleService extends __BaseService {
  static readonly GetAllPath = '/api/tasks/roles';
  static readonly CreateTaskRolePath = '/api/tasks/roles';
  static readonly GetTaskRoleForUpdatePath = '/api/tasks/roles/{id}/update';
  static readonly UpdateTaskRolePath = '/api/tasks/roles/{id}/update';
  static readonly DeleteTaskRolePath = '/api/tasks/roles/{id}';
  static readonly GetTaskRoleMapPath = '/api/tasks/roles/map';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `TaskRoleService.GetAllParams` containing the following parameters:
   *
   * - `sortFields`:
   *
   * - `sortCriteria`:
   *
   * - `pattern`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * @return Success
   */
  GetAllResponse(params: TaskRoleService.GetAllParams): __Observable<__StrictHttpResponse<ListQueryResultTaskRoleInfo>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    (params.sortFields || []).forEach(val => {if (val != null) __params = __params.append('sortFields', val.toString())});
    (params.sortCriteria || []).forEach(val => {if (val != null) __params = __params.append('sortCriteria', val.toString())});
    if (params.pattern != null) __params = __params.set('pattern', params.pattern.toString());
    if (params.pageSize != null) __params = __params.set('pageSize', params.pageSize.toString());
    if (params.pageNumber != null) __params = __params.set('pageNumber', params.pageNumber.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/tasks/roles`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ListQueryResultTaskRoleInfo>;
      })
    );
  }
  /**
   * @param params The `TaskRoleService.GetAllParams` containing the following parameters:
   *
   * - `sortFields`:
   *
   * - `sortCriteria`:
   *
   * - `pattern`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * @return Success
   */
  GetAll(params: TaskRoleService.GetAllParams): __Observable<ListQueryResultTaskRoleInfo> {
    return this.GetAllResponse(params).pipe(
      __map(_r => _r.body as ListQueryResultTaskRoleInfo)
    );
  }

  /**
   * @param command undefined
   */
  CreateTaskRoleResponse(command?: CreateTaskRoleCommand): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = command;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/tasks/roles`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param command undefined
   */
  CreateTaskRole(command?: CreateTaskRoleCommand): __Observable<null> {
    return this.CreateTaskRoleResponse(command).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param id undefined
   * @return Success
   */
  GetTaskRoleForUpdateResponse(id: string): __Observable<__StrictHttpResponse<UpdateTaskRoleCommand>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/tasks/roles/${id}/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UpdateTaskRoleCommand>;
      })
    );
  }
  /**
   * @param id undefined
   * @return Success
   */
  GetTaskRoleForUpdate(id: string): __Observable<UpdateTaskRoleCommand> {
    return this.GetTaskRoleForUpdateResponse(id).pipe(
      __map(_r => _r.body as UpdateTaskRoleCommand)
    );
  }

  /**
   * @param params The `TaskRoleService.UpdateTaskRoleParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `command`:
   */
  UpdateTaskRoleResponse(params: TaskRoleService.UpdateTaskRoleParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.command;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/tasks/roles/${params.id}/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `TaskRoleService.UpdateTaskRoleParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `command`:
   */
  UpdateTaskRole(params: TaskRoleService.UpdateTaskRoleParams): __Observable<null> {
    return this.UpdateTaskRoleResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param id undefined
   */
  DeleteTaskRoleResponse(id: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/tasks/roles/${id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param id undefined
   */
  DeleteTaskRole(id: string): __Observable<null> {
    return this.DeleteTaskRoleResponse(id).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param params The `TaskRoleService.GetTaskRoleMapParams` containing the following parameters:
   *
   * - `taskGroupId`:
   *
   * - `sortFields`:
   *
   * - `sortCriteria`:
   *
   * - `roleId`:
   *
   * - `pattern`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * @return Success
   */
  GetTaskRoleMapResponse(params: TaskRoleService.GetTaskRoleMapParams): __Observable<__StrictHttpResponse<ListQueryResultTaskRoleInfo>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.taskGroupId != null) __params = __params.set('taskGroupId', params.taskGroupId.toString());
    (params.sortFields || []).forEach(val => {if (val != null) __params = __params.append('sortFields', val.toString())});
    (params.sortCriteria || []).forEach(val => {if (val != null) __params = __params.append('sortCriteria', val.toString())});
    if (params.roleId != null) __params = __params.set('roleId', params.roleId.toString());
    if (params.pattern != null) __params = __params.set('pattern', params.pattern.toString());
    if (params.pageSize != null) __params = __params.set('pageSize', params.pageSize.toString());
    if (params.pageNumber != null) __params = __params.set('pageNumber', params.pageNumber.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/tasks/roles/map`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ListQueryResultTaskRoleInfo>;
      })
    );
  }
  /**
   * @param params The `TaskRoleService.GetTaskRoleMapParams` containing the following parameters:
   *
   * - `taskGroupId`:
   *
   * - `sortFields`:
   *
   * - `sortCriteria`:
   *
   * - `roleId`:
   *
   * - `pattern`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * @return Success
   */
  GetTaskRoleMap(params: TaskRoleService.GetTaskRoleMapParams): __Observable<ListQueryResultTaskRoleInfo> {
    return this.GetTaskRoleMapResponse(params).pipe(
      __map(_r => _r.body as ListQueryResultTaskRoleInfo)
    );
  }
}

module TaskRoleService {

  /**
   * Parameters for GetAll
   */
  export interface GetAllParams {
    sortFields?: Array<any>;
    sortCriteria?: Array<any>;
    pattern?: string;
    pageSize?: number;
    pageNumber?: number;
  }

  /**
   * Parameters for UpdateTaskRole
   */
  export interface UpdateTaskRoleParams {
    id: string;
    command?: UpdateTaskRoleCommand;
  }

  /**
   * Parameters for GetTaskRoleMap
   */
  export interface GetTaskRoleMapParams {
    taskGroupId?: string;
    sortFields?: Array<any>;
    sortCriteria?: Array<any>;
    roleId?: string;
    pattern?: string;
    pageSize?: number;
    pageNumber?: number;
  }
}

export { TaskRoleService }
